define('models/validator/zipcode',[
    'backbone',
    'models/validator/length'
], function(Backbone, LengthValidator){
    'use strict';

    return LengthValidator.extend({

        initialize: function(options){
            options = options || {};

            this.lookup = options.lookup;
        },

        defaults: {
            validationType: enums.validationType.zipCode,
            minLength: 5,
            maxLength: 5,
        },

        validate: function(val){
            this.set('value', val);

            var code = this.validateHasValue(val);
            
            if(this.isValid(code)){

                code = this.validateLength(val, this.get('minLength'), this.get('maxLength'));
                
                if(this.isValid(code)){

                    // Consider allowing full zipcodes using this expression: /^\d{5}(?:[-\s]\d{4})?$/
                    if(!/(^\d{5}$)/.test(val)){ // zipcode regex

                        code = enums.validationCode.incorrectFormat;

                    } else {

                        if(this.lookup !== false){

                            $.ajax({
                                type: 'GET',
                                async: false,
                                url: pf.lookupsURL + "/ZipCodes/" + val,
                                contentType: "application/json",
                                success: function () {
                                    code = enums.validationCode.ok;
                                },
                                error: function () {
                                    code = enums.validationCode.notAvailable;
                                }
                            });

                        }

                    }

                }

            }
            
            this.set('validationCode', code);

            return code;
        }

    });

});
